"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsupportedDetails = UnsupportedDetails;
exports["default"] = UnsupportedAccounts;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _constants = require("../../constants");
var _UnsupportedAccounts = require("./UnsupportedAccounts.styles");
function UnsupportedDetails(_ref) {
  var accounts = _ref.accounts,
    classes = _ref.classes,
    disclaimer = _ref.disclaimer;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "unsupported-details"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: classes.unsupportedList,
    "data-testid": "unsupported-list"
  }, accounts.map(function (account) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "".concat(account.institutionName, "-").concat(account.identifier),
      "data-testid": "unsupported-list-item"
    }, account.institutionName, " - ", account.accountName, " (***", account.lastFour, ")");
  })), /*#__PURE__*/_react["default"].createElement(_reactComponents.Divider, {
    kind: "light",
    style: {
      borderTop: '1px solid #EDF3F7'
    }
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: classes.disclaimer,
    "data-testid": "unsupported-disclaimer"
  }, disclaimer));
}
UnsupportedDetails.propTypes = {
  accounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  })).isRequired,
  classes: (0, _propTypes.shape)({}),
  disclaimer: _propTypes.string
};
UnsupportedDetails.defaultProps = {
  classes: {},
  disclaimer: _constants.UNSUPPORTED_ACCOUNTS_DISCLAIMER
};
function UnsupportedAccounts(_ref2) {
  var accounts = _ref2.accounts,
    disclaimer = _ref2.disclaimer;
  var classes = (0, _UnsupportedAccounts.useStyles)();
  var accordionData = [{
    id: 'unspportedAccounts',
    header: /*#__PURE__*/_react["default"].createElement("span", {
      className: classes.leadin
    }, accounts && accounts.length, " Unsupported Accounts"),
    details: /*#__PURE__*/_react["default"].createElement(UnsupportedDetails, {
      classes: classes,
      accounts: accounts,
      disclaimer: disclaimer
    })
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root,
    "data-testid": "unsupported-account-container"
  }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Accordion, {
    data: accordionData
  }));
}
UnsupportedAccounts.propTypes = {
  /**
   * A collection of accounts NOT supported by ACH transfers
   */
  accounts: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    identifier: _propTypes.string,
    institutionName: _propTypes.string,
    accountName: _propTypes.string,
    lastFour: _propTypes.string,
    balance: _propTypes.string
  })).isRequired,
  /**
   * Custom disclaimer
   */
  disclaimer: _propTypes.string
};
UnsupportedAccounts.defaultProps = {
  disclaimer: _constants.UNSUPPORTED_ACCOUNTS_DISCLAIMER
};
